<template>
<flat-button icon="add" :loading="queue.length > 0 " class="q-mr-md" label="Toevoegen"
>
  <template v-slot:loading>
    Uploading ({{ queue.length }})
  </template>
  <input type="file"
         multiple
         @change="processFiles"
         ref="fileInputRef"
         name="file" />
</flat-button>
<small> Max {{ maxUploadSize }}</small>
</template>

<script>
import { config } from '~INSTANCE'

export default {
  emits: ['update:documents', 'documentUploaded'],
  data () {
    return {
      queue: [],
      STATUS_PENDING: 'pending',
      STATUS_UPLOADING: 'uploading',
      STATUS_SUCCESS: 'success',
      STATUS_FAILED: 'failed',
    }
  },
  watch: {
    queue: {
      handler (files) {
        const uploading = files.filter((file) => {
          return file.status === this.STATUS_UPLOADING
        })
        for (let i = uploading.length; i < this.batchSize; i++) {
          const next = files.find((file) => {
            return file.status === this.STATUS_PENDING
          })
          if (next) {
            this._uploadFile(next)
          }
        }
      },
      deep: true,
    },
  },
  props: {
    uploadUrl: {
      required: true,
      type: String,
    },
    batchSize: {
      type: Number,
      default: 1,
    },
    documents: {
      type: Array,
      default: () => [],
    },
    canUpdate: {
      // TODO: aansluiten op permissies
      type: Boolean,
      default: true,
    },
  },
  computed: {
    maxUploadSize () {
      return config.maxUpload || '75mb'
    },
  },
  methods: {
    processFiles () {
      this.error = false
      const files = this.$refs.fileInputRef.files
      for (let i = 0; i < files.length; i++) {
        const file = {
          status: this.STATUS_PENDING,
          isNew: true,
          content: files[i],
          meta_data: {},
        }
        this.queue.push(file)
      }
      this.$refs.fileInputRef.value = null
    },
    async _uploadFile (file) {
      const data = new FormData()
      data.append('Content-Type', file.content.type)
      data.append('file', file.content)
      data.append('type', this.type)
      file.status = this.STATUS_UPLOADING
      try {
        const response = await axios.post(this.uploadUrl, data)
        file.status = this.STATUS_SUCCESS
        file.name = response.data.name
        file.extension = response.data.extension
        file.type = response.data.type
        file.id = response.data.id
        this.$emit('update:documents', [...this.documents, file])
        this.$emit('documentUploaded', file)
      } catch (error) {
        file.status = this.STATUS_FAILED
        if (error.response?.status === 413) {
          await this.$toast('error', `Bestand ${file.content.name} is groter dan ${this.maxUploadSize} en kan niet worden opgeslagen.`)
        } else if (error.response?.status === 400 && error.response.data.error ===	"Invalid file type") {
          await this.$toast('error', `Bestanden van het type van ${file.content.name} zijn niet toegestaan.`)
        } else {
          await this.$toast('error', `Bestand ${file.content.name} kan niet worden opgeslagen.`)
        }
      } finally {
        this.cleanupQueue()
      }
    },
    cleanupQueue: function () {
      for (let index = this.queue.length - 1; index >= 0; index--) {
        let item = this.queue[index]
        if (item.status !== this.STATUS_PENDING &&
            item.status !== this.STATUS_UPLOADING) {
          this.queue.splice(index, 1)
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
input[type="file"] {
  position: absolute;

  top: 0;
  right: 0;
  margin: 0;
  opacity: 0;

  -ms-filter: 'alpha(opacity=0)';
  font-size: 200px !important;
  direction: ltr;
  cursor: pointer;
}
</style>
